<div>
  <button
    type="button"
    class="btn-circle btn-xl btn btn-absolute-corner-right"
    ngClass="btn-{{ type }}"
  >
    {{ label }}
  </button>
</div>
